import React from 'react';
import { Box, LinearProgress } from '@mafc/trolly';

import Card from 'common/Card';
import NotifcationLayout from 'common/Notification/NotificationLayout';
import { IAddress } from 'services/user/types/user.types';
import SingleAddress from '../SingleAddress';

interface Props {
  error?: string;
  addressDetails: IAddress;
  loading?: boolean;
}

const DeliveryLayout: React.FC<Props> = props => {
  const { error = '', addressDetails, loading = false } = props;

  return (
    <Card testId="__checkout_delivery_info_container__">
      {error !== '' && (
        <Box my={2}>
          <NotifcationLayout>{error}</NotifcationLayout>
        </Box>
      )}
      {addressDetails && <SingleAddress addressDetails={addressDetails} isLocationCxEnable />}
      {loading && <LinearProgress position="bottom" />}
    </Card>
  );
};
export default DeliveryLayout;
